import { Injectable } from '@angular/core';
import { Facility } from '../../model/locations/facility';
import { BaseTableService } from './base-table.service';
import { FacilitySearchResult } from 'src/app/model/locations/facility-search-results';

@Injectable({
  providedIn: 'root',
})
export class FacilityTableService extends BaseTableService<FacilitySearchResult> {
  constructor() {
    super();
  }
}
